<template>
	<div class="newsinfo">
		<div class="newsinfo-box" v-for="item in news">
			<div class="newsinfo-boxleft">
				<div class="img">
					<img :src="item.news_img" />
				</div>
			</div>
			<div class="newsinfo-boxright">
				<div class="newsinfo-title" :title="item.news_title">{{item.news_title}}</div>
				<div class="newsinfo-date">{{item.upload_time}}</div>
				<div class="newsinfo-write">{{item.desc}}</div>
				<div class="newsinfo-know" @click="open(item)">
					<div class="moreto">MORE</div>
					<div class="sign-right-white">
						<SvgIcon svg-name="signRightWhite" size="40"></SvgIcon>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SvgIcon from './SvgIcon.vue'
	// import axios from 'axios'
	import request from '../common/request.js'

	export default {
		name: 'newsinfo',
		data() {
			return {
				news: [
					// {
					// 	title: '乐范联合厦航，助力安心复工',
					// 	info: '此次乐范与厦航的合作，不仅仅是赠送口罩这么简单，领取完口罩后，点击“随便逛逛”，里面还有乐范为大家准备的厦航专属福利......',
					// 	time: ' 2020-04-02',
					// 	url: 'http://news.jxntv.cn/2020/0402/9366121.shtml',
					// 	newsBg: this.GLOBAL.imgHost + '/images/newsinfo/2.jpg'
					// },
					// {
					// 	title: '乐范健康科技销售额逆势增长236%',
					// 	info: '没人会想到,2020年的春节让人如此焦虑,快速发展中国经济竟然被新冠肺炎疫情踩了一脚刹车。随着“封城”“交通管制”......',
					// 	time: '2020-03-25',
					// 	url: 'https://tech.china.com/article/20200325/20200325486377.html',
					// 	newsBg: this.GLOBAL.imgHost + '/images/newsinfo/1.jpg'
					// },
					// {
					// 	title: '小米眼仪测评：充电2小时按摩100分钟',
					// 	info: '小米被誉为“国货之光”，有多牛就不必多说了，从创办到上市，再到国货之光，到现在已经十年了，期间我们也看到了许多小米......',
					// 	time: '2020-02-18',
					// 	url: 'https://www.toutiao.com/a6794635368181268995/',
					// 	newsBg: this.GLOBAL.imgHost + '/images/newsinfo/3.jpg'
					// },
					// {
					// 	title: '乐范双色颈枕让你的颈椎不再无处安放',
					// 	info: '经常出差或者旅行的小伙伴都知道无论是在飞机、火车还是汽车上，时间久了我们都会出现一个"无处安放"的"大脑袋"......',
					// 	url: 'https://www.sohu.com/a/333936067_100210898',
					// 	time: '2019-08-15',
					// 	newsBg: this.GLOBAL.imgHost + '/images/newsinfo/4.jpg'
					// },
					// {
					// 	title: '乐范脚部揉捏按摩器常伴左右',
					// 	info: '众所周知，人体脚底有诸多穴位，当穴位被打通后，可以改善血液循环，加快人体新陈代谢。不仅如此，经常进行足底按摩......',
					// 	time: '2018-08-16',
					// 	url: 'https://zhuanlan.zhihu.com/p/42130491',
					// 	newsBg: this.GLOBAL.imgHost + '/images/newsinfo/5.jpg'
					// },
				],
			}
		},
		components: {
			SvgIcon,
		},
		mounted() {
			// this.listData()
			this.getNewsList()
		},
		methods: {
			async getNewsList() {
				// 获取新闻列表
				// request.uniRequest('/news/getNewsList')
				// 	.then(res => {
				// 		// this.posters = res.data.filter(item => item.web_type == 0)
				// 		this.news = res.data
				// 	}).catch(e => {})
				let res = await this.$Cloud.table(`lf_func_lefan_news`).get({ page: 0, pageSize: 1000 })
				
				console.log('获取新闻列表',res)
				
				const {code,data} = res
				if(code == 200) {
					this.news = data.filter(item=>item.is_check==2)
				}
			},
			open(item) {
				let routeUrl
				let startTime
				let endTime
				let timestamp
				timestamp = new Date().getTime()
				if(item.effect_time) {
					startTime = new Date(item.effect_time[0]).getTime()
					endTime = new Date(item.effect_time[1]).getTime()
				}
				if (startTime && endTime && timestamp <= endTime && timestamp >= startTime) {
					routeUrl = item.openurl
					window.open(routeUrl, '_blank');
				} else {
					routeUrl = this.$router.resolve({
						path: "/news",
						query: {
							id: item._id
						}
					});
					window.open(routeUrl.href, '_blank');
				}
			},
		}
	}
</script>

<style>
	.newsinfo {
		min-width: 100%;
		padding-top: 7rem;
		padding-bottom: 10rem;
		min-height: 700px;
		background-color: #FFFFFF;
	}

	.newsinfo .newsinfo-box {
		width: 100%;
		display: flex;
		padding-top: 1rem;
		padding-bottom: 1.5rem;
	}

	.newsinfo .newsinfo-box .newsinfo-boxleft {
		width: 50%;
	}

	.newsinfo .newsinfo-box .newsinfo-boxleft .img {
		width: 100%;
		font-size: 0;
	}

	.newsinfo .newsinfo-box .newsinfo-boxleft img {
		width: 100%;
		/* height: 100%; */
		
	}

	.newsinfo .newsinfo-box .newsinfo-boxright {
		width: 50%;
		height: 18rem;
		background: rgba(244, 244, 244, 1);
		position: relative;
	}

	.newsinfo .newsinfo-box .newsinfo-boxright .newsinfo-title {
		font-size: 18px;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		height: 70px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow:ellipsis;
		color: rgba(24, 24, 24, 1);
		line-height: 70px;
		text-align: left;
		padding-left: 10%;
		padding-right: 10%;
	}

	.newsinfo .newsinfo-box .newsinfo-boxright .newsinfo-date {
		font-size: 0.9rem;

		font-weight: 400;
		color: rgba(164, 164, 164, 1);
		line-height: 1.25rem;
		text-align: left;
		padding-left: 10%;
	}

	.newsinfo .newsinfo-box .newsinfo-boxright .newsinfo-write {
		width: 80%;
		font-size: 0.9rem;

		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		/* line-height:55px; */
		text-align: left;
		padding-left: 10%;
		padding-top: 5%;
		padding-right: 10%;
	}

	.newsinfo .newsinfo-box .newsinfo-boxright .newsinfo-know {
		width: 9.375rem;
		height: 2.5rem;
		background: linear-gradient(90deg, rgba(0, 199, 133, 1), rgba(9, 219, 184, 1));
		position: absolute;
		/* left: 71%; */
		right: 0;
		bottom: 0;
		/* top: 86%; */
		color: rgba(255, 255, 255, 1);
		font-size: 1rem;

	}

	.newsinfo .newsinfo-box .newsinfo-boxright .newsinfo-know:hover {
		cursor: pointer
	}

	.newsinfo .newsinfo-box .newsinfo-boxright .newsinfo-know .moreto {
		color: rgba(255, 255, 255, 1);
		font-size: 0.9rem;
		/* padding-left: 15%; */
		/* padding-top: 10%;*/
		line-height: 40px;
	}

	.newsinfo .newsinfo-box .newsinfo-boxright .newsinfo-know .sign-right-white {
		position: absolute;
		left: 70%;
		top: 0%;
	}
</style>
